import { useIntl } from 'react-intl';
import { Popper } from '@m/alchemy-ui/Popper';
import { PopperBox } from '@m/alchemy-ui/PopperBox';
import { MediaButton, PlayPauseContainer } from './PlayPauseButton.styled';

interface PlayPauseButtonProps {
  isPlaying: boolean;
  isAutoPaused: boolean;
  togglePlayPause: () => void;
}

export const PlayPauseButton = ({ isPlaying, isAutoPaused, togglePlayPause }: PlayPauseButtonProps) => {
  const intl = useIntl();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      togglePlayPause();
    }
  };

  return (
    <PlayPauseContainer data-testid="play-pause-button-container" onClick={togglePlayPause}>
      <Popper
        placement="left"
        tooltipOptions={{ mode: 'description', delay: 50 }}
        mode="tooltip"
        overlay={
          <PopperBox hasArrow colorScheme="alchemyDark">
            {isPlaying
              ? isAutoPaused
                ? intl.formatMessage({ id: 'playCarousel', defaultMessage: 'Play Carousel' })
                : intl.formatMessage({ id: 'pauseCarousel', defaultMessage: 'Pause Carousel' })
              : intl.formatMessage({ id: 'playCarousel', defaultMessage: 'Play Carousel' })}
          </PopperBox>
        }
        trigger={
          <MediaButton
            data-testid="play-pause-button"
            role="button"
            tabIndex={0}
            aria-label={
              isPlaying
                ? intl.formatMessage({ id: 'pause', defaultMessage: 'Pause' })
                : intl.formatMessage({ id: 'play', defaultMessage: 'Play' })
            }
            aria-pressed={isPlaying}
            onKeyDown={handleKeyDown}
          >
            <svg
              data-testid="play-pause-button-icon"
              style={isPlaying && isAutoPaused ? { filter: 'grayscale(100%)', opacity: 0.5 } : {}}
            >
              <use href={isPlaying && !isAutoPaused ? '#pause' : '#play'} />
            </svg>
          </MediaButton>
        }
      />
    </PlayPauseContainer>
  );
};
